import React, { useCallback, useMemo, useState } from 'react';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import s from './EditWarehouseModal.module.css';
import { QuickActionButton } from '../QuickActionButton/QuickActionButton';
import {
    loadWarehouseListRequest,
    sendMoveAllInventoryRequest,
    sendMoveFilteredInventoriesRequest,
} from '../../store/slices/boardSlice';
import { SearchModal } from '../SearchModal/SearchModal';

export function EditWarehouseModal({
    warehouse,
    onWarehouseRename,
    isLeftModeModal,
    deleteWarehouse,
    hideOverlay,
    setIsEditWarehouseMode,
}) {
    const [buttonsData, setButtonsData] = useState([]);
    const [isMoveAllInventoryMode, setIsMoveAllInventoryMode] = useState(false);
    const warehouseData = useSelector((state) => state.board);
    const hasFullAccess = useSelector((state) => state.restrictions);
    const isWarehouseEmpty =
        warehouseData.find((item) => item.id === warehouse.id).items.length === 0;
    const dispatch = useDispatch();
    const filterValue = useSelector((state) => state.filter);
    const filteredInventories = useMemo(
        () =>
            warehouseData
                .find((item) => item.id === warehouse.id)
                .items.filter((item) =>
                    item.title.toLowerCase().includes(filterValue.toLowerCase())
                ),
        [warehouseData, filterValue]
    );

    const moveAllInventory = (warehouseClick) => {
        const payload = {
            fromWarehouseId: warehouse.id,
            toWarehouseId: warehouseClick.id,
        };
        dispatch(sendMoveAllInventoryRequest(payload));
        setIsEditWarehouseMode(false);
        hideOverlay();
    };

    const moveFilteredInventories = (warehouseClick) => {
        const payload = {
            fromWarehouseId: warehouse.id,
            toWarehouseId: warehouseClick.id,
            filteredInventories,
        };
        dispatch(sendMoveFilteredInventoriesRequest(payload));
        setIsEditWarehouseMode(false);
        hideOverlay();
    };

    const moveInventory = filterValue ? moveFilteredInventories : moveAllInventory;

    const loadWarehouseList = () => {
        const warehouseList = dispatch(loadWarehouseListRequest);
        warehouseList
            .then((response) => response.json())
            .then((data) => {
                setButtonsData(data.response.filter((item) => item.id !== warehouse.id));
            });
    };

    const deleteWarehouseCallback = useCallback(() => {
        if (isWarehouseEmpty) {
            deleteWarehouse(warehouse.id);
            hideOverlay();
        } else {
            swal({
                text: i18next.t('EditWarehouseModal.deleteWarehouseCallback.text'),
                cancel: false,
                confirm: true,
                button: {
                    text: i18next.t('EditWarehouseModal.deleteWarehouseCallback.button.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-light',
                },
            });
            setIsEditWarehouseMode(false);
        }
        hideOverlay();
    }, [warehouse, deleteWarehouse, setIsEditWarehouseMode]);

    return (
        <div
            className={cx(s.editWarehouseModal, {
                [s.leftMode]: isLeftModeModal,
            })}
        >
            {!isMoveAllInventoryMode && (
                <div>
                    {!warehouse.is_attached_to_project && hasFullAccess && (
                        <div data-id="warehouse-rename-button" onClick={onWarehouseRename}>
                            <QuickActionButton buttonText={i18next.t('EditWarehouseModal.return.QuickActionButton.rename')} />
                        </div>
                    )}
                    {warehouse.items.length !== 0 && warehouseData.length > 1 && (
                        <div
                            data-id="move-all-inventory-button"
                            onClick={() => {
                                setIsMoveAllInventoryMode(true);
                                loadWarehouseList();
                            }}
                        >
                            {!filterValue &&
                                <QuickActionButton buttonText={i18next.t('EditWarehouseModal.return.QuickActionButton.moveAll')} />
                            }
                            {filterValue && (
                                <QuickActionButton buttonText={i18next.t('EditWarehouseModal.return.QuickActionButton.moveSelected')} />
                            )}
                        </div>
                    )}
                    <div data-id="delete-warehouse-button" onClick={deleteWarehouseCallback}>
                        <QuickActionButton buttonText={i18next.t('EditWarehouseModal.return.QuickActionButton.delete')} />
                    </div>
                </div>
            )}

            {isMoveAllInventoryMode && (
                <SearchModal
                    titleText={i18next.t('EditWarehouseModal.return.SearchModal.titleText')}
                    buttonClick={moveInventory}
                    buttonsData={buttonsData}
                    hideOverlay={hideOverlay}
                    setIsEditWarehouseMode={setIsEditWarehouseMode}
                />
            )}
        </div>
    );
}
